import qs from 'querystring'

import { omit } from 'lodash/fp'
import { NextRouter } from 'next/router'

export const goToPage = (searchParams: URLSearchParams, router: NextRouter, path: string, byZone?: string[]): void => {
  const queryString = Array.from(searchParams.entries()).reduce(
    (acc, item) => ({
      ...acc,
      [item[0]]: item[1],
    }),
    {}
  )
  const queryStringWithByZone = { ...omit(['byZone'], queryString), byZone }
  const queryStringWithoutByZone = { ...omit(['byZone'], queryString) }

  router.replace(
    `${path}${
      Object.keys(queryStringWithByZone).length >= 1 && Object.values(queryStringWithByZone).every(Boolean)
        ? `?${qs.stringify(queryStringWithByZone)}` // TODO: we could use URLSearchParams
        : `?${qs.stringify(queryStringWithoutByZone)}`
    }`
  )
}
